import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../Auth/Login";
import Home from "../Pages/Home";
import CarLists from "../Pages/CarLists";
import CarDetails from "../Pages/Components/CarDetails";
 import UploadCar from "../Pages/UploadCar";  
import MyLayout from "../Layout/MyLayout";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import Contact from "../Pages/Contact";
import AboutUs from "../Pages/AboutUs";
import Profile from "../Pages/Profile";
import Valuation from "../Pages/Valuation";
import Compare from "../Pages/Compare";
import EmiCalculator from "../Pages/EmiCalculator";
import WarrantyPolicy from "../Pages/WarrantyPolicy";
import AdminRoutes from "../../Admin/AdminRoutes";
import PartnerRoutes from "../../Partner/PartnerRoutes";

const MyRoutes = () => {
  return (
    <Routes>
      <Route path="/admin/*" element={<AdminRoutes />} />
      <Route path="/partner/*" element={<PartnerRoutes />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<Login />} />

      <Route path="/" element={<MyLayout />}>
        <Route index element={<Home />} />
        <Route path="cars" element={<CarLists />} />
        <Route path="car/:id" element={<CarDetails />} />
        <Route path="upload-car" element={<UploadCar />} />
        <Route path="upload-car/:id" element={<UploadCar />} />
        <Route path="valuation" element={<Valuation />} />
        <Route path="compare" element={<Compare />} />
        <Route path="finance" element={<EmiCalculator />} />
        <Route path="warranty" element={<WarrantyPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="contact" element={<Contact />} /> 
        <Route path="/about" element={<AboutUs />} />
        <Route path="/profile" element={<Profile />} />
      </Route>
    </Routes>
  );
};

export default MyRoutes;
